/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ads-page{display:block;width:100%;padding:25px}ads-page .panel{border:none;box-shadow:1px 0 20px rgba(0,0,0,.05);border-radius:4px;background-color:#fff}ads-page .panel>.header{background-color:#fafafa;border:1px solid #eff1f2;padding:15px;margin-bottom:15px;font-weight:500;color:#555}ads-page .panel>.input-container{margin-right:15px;margin-left:15px}ads-page .panel>.input-container>textarea{max-width:750px;height:150px}ads-page .panel>.setting-toggle-container{margin-left:15px}ads-page .panel>.save-button{margin:0 0 30px 15px}"];
export { styles as styles };
